import React from "react";
import { currencyBankSlipFormat } from "@utils/utils";
import {
  getAlphaNumericDate,
  sumOfSalaryCalculate,
} from "@utils/utils";
import { MEEZAN_BANK_ACCOUNT } from "@utils/constants";
export class BankSlipPrint extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="col-10" style={BankSlipWrapper}>
        <h5 style={BankSlipHeader}>To Whom It May Concern,</h5>
        <br />
        <h5 style={BankSlipData}>
          We, Shayan Solutions, would like to request the transfer of salaries
          of our employees through our Meezan account ({MEEZAN_BANK_ACCOUNT}) at
          Liberty Market Branch, Lahore against{" "}
          <b>{this.props.slipData.cheque_no}</b> for the month of{" "}
          <b>{getAlphaNumericDate(this.props.slipData.slip_month)}.</b> The total amount to
          be transferred is{" "}
          <b>
            {currencyBankSlipFormat(
              sumOfSalaryCalculate(this.props.slipData.employees)
            )}
          </b>
          , which is enclosed in the cheque{" "}
          <b>{this.props.slipData.cheque_no}.</b>
        </h5>
        <br />
        <h5 style={BankSlipData}>
          We request you to transfer the salaries to the bank accounts listed
          below:
        </h5>
        <br />
        <table style={table}>
          <tr>
            <th style={tableHead}>Employee Name</th>
            <th style={tableHead}>Account Number</th>
            <th colSpan={2} style={tableHead}>
              Salary
            </th>
          </tr>
          {this.props.slipData.employees?.map(function (employee) {
            return (
              <tr key={employee._id}>
                <td style={tableData}>{employee.name}</td>
                <td style={tableData}>
                  {employee.account_no ? employee.account_no : ""}
                </td>
                <td style={tableDataSM}>RS</td>
                <td style={tableData}>
                  {currencyBankSlipFormat(employee.salary)}
                </td>
              </tr>
            );
          })}
        </table>
        <br />
        <h5 style={BankSlipData}>
          Please confirm the receipt of the cheque and inform us once the
          transfer has been completed. We request you to inform us of any issues
          or discrepancies that may arise during the transfer process.
        </h5>
        <h5 style={BankSlipData}>Thank you for your cooperation.</h5>
        <h5 style={BankSlipData}>Sincerely,</h5>
        <br />
        <h5 style={BankSlipFootor}>Arslan Ali</h5>
        <h5 style={CEOBankSlipFootor}>CEO</h5>
        <br />
        <div style={CEOSig} />
      </div>
    );
  }
}

export default BankSlipPrint;

const BankSlipWrapper = {
  fontFamily: "Arial, Helvetica, sans-serif",
  padding: "0px 24px 0px 24px",
  margin: "auto",
};
const BankSlipHeader = {
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "26px",
  marginTop: "2.5rem",
};
const BankSlipFootor = {
  textAlign: "Left",
  fontWeight: "bold",
  fontSize: "18px",
};
const CEOBankSlipFootor = {
  textAlign: "Left",
  fontWeight: "bold",
  fontSize: "18px",
  marginTop: "0rem",
};
const BankSlipData = {
  textAlign: "justify",
  fontSize: "18px",
};
const table = {
  textAlign: "center",
  width: "100%",
  border: "1px solid black",
  bordercollapse: "collapse",
  marginleft: "auto",
  marginright: "auto",
};
const tableHead = {
  border: "1px solid black",
  bordercollapse: "collapse",
  fontSize: "18px",
  fontWeight: "bold",
  width: "33%",
};

const tableData = {
  border: "1px solid black",
  borderLeft: "none",
  fontSize: "18px",
  width: "30%",
};
const tableDataSM = {
  border: "1px solid black",
  borderRight: "none",
  fontSize: "18px",
  minWidth: "50px",
};
const CEOSig = {
  width: "200px",
  borderTop: "2px solid black",
};
